import React, { useState } from "react";
import { ModalThemMoiVaSua } from "./ModalThemMoiVaSua";

export const BtnThemMoi = ({ onReload, disabled }) => {
    const [show, setShow] = useState(false);
    return (
        <>
            <button type="button" className="btn btn-border-new" onClick={() => setShow(true)} disabled={disabled}>
                <span>
                    <img
                        src="/app-assets/images/icon-them-moi-cam-do-v2.png"
                        style={{ paddingBottom: "5px", marginRight: '6px' }}
                        alt="Thêm mới"
                    />
                    Thêm mới
                </span>
            </button>
            {show && (
                <ModalThemMoiVaSua 
                    show={show} 
                    onHide={() => setShow(false)} 
                    onSearch={onReload}
                />
            )}
        </>
    );
};